import { useEffect, useSyncExternalStore } from 'react';
import { useAuth } from '../App';

// Shared cache of coach-verified player ids (green check across the app).
let ids = new Set();
let loaded = false;
let loading = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

export const loadLevelVerified = async (API, force = false) => {
  if (!API || loading || (loaded && !force)) return;
  loading = true;
  try {
    const { data } = await API.get('/level-verified/ids');
    ids = new Set(data || []);
    loaded = true;
    emit();
  } catch { /* not logged in */ } finally { loading = false; }
};

export const setLevelVerifiedLocal = (id, on) => {
  ids = new Set(ids);
  if (on) ids.add(id); else ids.delete(id);
  emit();
};

export const useLevelVerified = () => {
  const { API, user } = useAuth() || {};
  useEffect(() => { if (user) loadLevelVerified(API); }, [API, user]);
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => ids);
};
